
import React from 'react';

const Leadership: React.FC = () => {
  const leaders = [
    {
      name: 'Hidenori Inada',
      position: 'Representative Director',
      bio: 'Leading HI-TAK with a vision to advance deep hole processing technology globally. Under his leadership, the company has achieved breakthrough innovations including φ1mm × 400mm deep hole processing capabilities.'
    },
    {
      name: 'Yoshiro Yamashita',
      position: 'Director (Representative Director of Kashiwa Group)',
      bio: 'Brings extensive industry experience and strategic guidance as Director, representing Kashiwa Group, the major shareholder supporting HI-TAK\'s growth and expansion.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#001E3C] mb-4">
            Leadership Team
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Experienced executives driving innovation and excellence in precision manufacturing
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto">
          {leaders.map((leader, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-8 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-2xl font-bold text-[#001E3C] mb-2">
                {leader.name}
              </h3>
              <p className="text-[#00D9C9] font-semibold mb-4">
                {leader.position}
              </p>
              <p className="text-gray-600 leading-relaxed">
                {leader.bio}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Leadership;
